import { entityUuidRegexStr } from "../../../../../shared/constants/entityUuidRegex";

export const apiChildrenPathRegex = new RegExp(`/v4/Entities/${entityUuidRegexStr}/Children`);
